import { render, staticRenderFns } from "./LikertScale.vue?vue&type=template&id=8e126af2&scoped=true&"
import script from "./LikertScale.vue?vue&type=script&lang=ts&"
export * from "./LikertScale.vue?vue&type=script&lang=ts&"
import style0 from "./LikertScale.vue?vue&type=style&index=0&id=8e126af2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e126af2",
  null
  
)

export default component.exports